export const openTakeover = () => ({
	type: 'OPEN_TAKEOVER',
})

export const closeTakeover = () => ({
	type: 'CLOSE_TAKEOVER',
})
